import {fetchApiWithRedirects} from "~/utils/apiFetch.ts";
import {authHeaders} from "~/composables/apiAuth.js";

export const useClientFetch = async (url, opts = {}) => {
    const config = useRuntimeConfig()

    if (!config || !config.public) {
        throw new Error('Runtime config is not available');
    }

    const headers = authHeaders({
        accept: 'application/json',
        ...opts?.headers,
        referer: config.public.baseURL,
        'Accept-Language': config.public.locale,
    })

    const method = String(opts.method ?? 'GET').toUpperCase()
    const isGet = method === 'GET'
    const timeout = typeof opts.timeout === 'number' ? opts.timeout : (isGet ? 60000 : 20000)
    const retry = typeof opts.retry === 'number' ? opts.retry : (isGet ? 1 : 0)
    const retryDelay = typeof opts.retryDelay === 'number' ? opts.retryDelay : 250

    let lastError

    for (let attempt = 0; attempt <= retry; attempt++) {
        try {
            return await fetchApiWithRedirects(url, {
                query: opts.query,
                body: opts.body,
                method,
                timeout,
                ...opts,
                headers,
            }, 0, config.public)
        } catch (error) {
            lastError = error

            if (attempt < retry) {
                await new Promise(resolve => setTimeout(resolve, retryDelay))
                continue
            }

            throw error
        }
    }

    throw lastError
}
